import React, { useEffect, useState } from "react";
import moment from "moment";
import 'moment/locale/fr';
import { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { frCA } from 'date-fns/locale';
import { CheckCircleIcon, XMarkIcon, } from '@heroicons/react/20/solid';
import InfosBasiqueAffaire from "../../components/InfosBasiqueAffaire"
import QuestionnaireModal from "../../components/ModalQuestionnaire/QuestionnaireModal";

registerLocale("fr", frCA);
moment.locale('fr')

function TabsAffaireInformationscertification(args) {
    //console.log("tabs affaire info certification", args)
    const [event, setEvent] = useState(null);
    const [action, setAction] = useState(null);
    /** rdv */
    const [rdv, setRdv] = useState(null);
    const [idRdv] = useState(null);
    const [rdvNotaire, setRdvNotaire] = useState(null); // Stocke le RDV "Rendez vous notaire"
    const [rdvSignature, setRdvSignature] = useState(null); // Stocke le rdv de signature
    //modal questionnaire
    const [open2, setOpen2] = useState(false);

    /** doc notarie */
    const [canvasErreurDoc, setCanvasErreurDoc] = useState(false);
    const toggleCanvasErreurDoc = () => setCanvasErreurDoc(!canvasErreurDoc);


    // RÉCUPÉRATION DATA  *******************************************************
    //get info event
    const getEvent = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/event?filterByFormula=SEARCH("${args.affaire.id}",{autre_demarche})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        //console.log("all event transaction", res.records);
                        setEvent(res.records[0]);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };
    //get info RDV
    const getRdv = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/rdv?filterByFormula=SEARCH("${args.affaire.id}",{autre_demarche})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        // console.log("all rdv certification", res.records);
                        setRdv(res.records);
                        // 🔍 Trouver le RDV de signature
                        const rdvSignature = res.records.find(rdv => rdv.fields.nom.toLowerCase().includes("signature")) || null;
                        // ✅ Stocker les infos dans le state si trouvé
                        if (rdvSignature) { setRdvSignature(rdvSignature); } else { setRdvSignature(null); }

                        // 🔍 Trouver le RDV "Rendez vous notaire"
                        const rdvTrouve = res.records.find(rdv => rdv.fields.nom === "Rendez-vous notaire");
                        // ✅ Stocker les infos dans le state si trouvé
                        if (rdvTrouve) { setRdvNotaire(rdvTrouve); } else { setRdvNotaire(null); }
                        if (rdvTrouve) {
                            setRdvNotaire(rdvTrouve);
                        } else {
                            setRdvNotaire(null); // Aucun RDV trouvé
                        }
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };
    //get info action
    const getActions = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions?filterByFormula=SEARCH("${args.affaire.id}",{autre_demarche})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        //console.log("all action certification", res.records[1].doc_pdf);
                        setAction(res.records);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getEvent();
    }, []);

    useEffect(() => {
        getRdv();
        getActions();
    }, [event]);



    moment.locale('fr')


    //console.log("event certification", event)
    //console.log("rdvNotaire", rdvNotaire)
    //console.log("rdvSignature", rdvSignature)
    //console.log("args affaire", args)
    if (event !== null && rdv !== null && action !== null) {
        return (
            <>
                <InfosBasiqueAffaire type="certification" affaire={args.affaire} />

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/** Composant  questionnaire de connaissance */}
                    <div className="mt-8">
                        <h5 className="flex-auto truncate text-sm font-semibold leading-6 text-gray-700 mb-3"><b>Questionnaire(s) d'état civil</b></h5>
                        <div className="bg-white rounded-lg p-8 ">
                            {action.map((col, i) => (
                                <>

                                    {action[i].fields.nom === "Questionnaire état civil" &&
                                        <>
                                            <div>
                                                <span className="mb-3 badge-acheteur">
                                                    Client
                                                </span>
                                                <div className="flex flex-row">

                                                    <h5><b>{args.affaire.nom_from_user}{" "} {args.affaire.prenom_from_user}</b></h5>

                                                </div>
                                                {action[i].fields.statut === "à faire" && <><p className="text-sm font-regular leading-6 text-gray-500 flex items-center"><b><XMarkIcon className='size-6 mr-1 inline-flex' /> Pas encore renseigné</b></p></>}
                                                {action[i].fields.statut === "fait" &&
                                                    <>
                                                        <div className="rounded-md bg-emerald-50 p-4 my-4">
                                                            <div className="flex">
                                                                <div className="shrink-0">
                                                                    <CheckCircleIcon aria-hidden="true" className="size-5 text-emerald-400" />
                                                                </div>
                                                                <div className="ml-3">
                                                                    <h3 className="text-sm font-medium text-emerald-800">Renseigné</h3>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <button
                                                            className="btn-main w-fit"
                                                            onClick={() => setOpen2(action[i].id)} // 👈 on passe directement le param
                                                        >
                                                            Voir les informations
                                                        </button>
                                                        <QuestionnaireModal
                                                            open={!!open2}
                                                            onClose={() => setOpen2(false)}
                                                            id_action={open2} // 👈 id_action passé à la modal
                                                            title="Questionnaire"
                                                        />
                                                    </>}
                                            </div>
                                        </>
                                    }
                                </>
                            ))}
                        </div>
                    </div>


                </div>

            </>


        );
    }

    return (<></>)
}

export default TabsAffaireInformationscertification;